import {Component, Inject, ViewChild} from '@angular/core';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetallePeticionComponent } from '../GestionPeticiones/detalle-peticion/detalle-peticion.component';
import { GestionesVariasService} from "../services/bd/GestionesVarias/gestiones-varias.service";
import { MatTableDataSource, MatTableDataSourcePaginator} from "@angular/material/table";
import { MatPaginator} from "@angular/material/paginator";
import { MatSort } from '@angular/material/sort';
import { HojasCallCenterComponent} from "../hojas-call-center.component";
import { DetPeticionCorredoresComponent} from "../GestionPeticiones/det-peticion-corredores/det-peticion-corredores.component";
@Component({
  selector: 'ral-listado-peticiones',
  templateUrl: './listado-peticiones.component.html',
  styleUrls: ['./listado-peticiones.component.scss']
})
export class ListadoPeticionesComponent extends VentanaFlotante
{
  //Datos que le llegan del buscador

  controlGestion:string = "";
  //Listado de peticiones que se han encontrado con los parametros pasados
  peticionesEncontradas : PeticionC[] = [];
  protected displayedColumns : string[]=["id","fecha","cliente","titular","cia","matricula","sub_del","estado"];
  dataSource = new MatTableDataSource(this.peticionesEncontradas);
  permisoGestionUsuario: string[] = ["rluque", "acano", "shernandez", "szalla", "nalcarria", "bvite", "ppalao"]
  formInic: HojasCallCenterComponent;
  constructor
  (
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any|null,
    private dDetalle:MatDialog,
    private gestion: GestionesVariasService
  )
  {
    super(dialogRef,data);
    this.formInic = this.data.hojaprin;
  }

  @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | null=null;
  @ViewChild(MatSort) sort: MatSort| null=null;
  ngOnInit():void
  {
    this.controlGestion = this.data.filtros.cia;
    this.realizarBusquedaPeticiones
    (
      this.data.filtros.cia,
      this.data.filtros.id,
      this.data.filtros.estado,
      this.data.filtros.fInicio,
      this.data.filtros.fFin,
      this.data.filtros.matricula
    );
  }

  realizarBusquedaPeticiones(cia:string, id:number,estado:number, fInicio:Date, fFin:Date, matricula:string)
  {
    let fini = fInicio.toISOString().split('T')[0];
    let ffin = fFin.toISOString().split('T')[0];

    if (cia == 'CORREDORES'){
      this.gestion.getCorredor(this.data.token, cia, id, fini, ffin, estado, matricula).then(
        res => {
          if (res.length > 0){
            this.peticionesEncontradas = res;
            this.dataSource.data = this.peticionesEncontradas;
          }else {
            this.data.hojaprin.mostrarArgumentario("Resultado", ["No se han encontrado datos con los filtros introducidos."]);
            this.dialogRef.close();
          }
        },
        err => {
          this.data.hojaprin.mostrarArgumentario("Resultado", ["Ha habido un problema al buscar los datos: ", err.message()], false, true, true);
          this.dialogRef.close();
        }).finally(() => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }else{
      this.gestion.getListado(this.data.token, cia, id, fini, ffin, estado, matricula).then(
        res => {
          if (res.length > 0){
            this.peticionesEncontradas = res;
            this.dataSource.data = this.peticionesEncontradas;
          }else {
            this.data.hojaprin.mostrarArgumentario("Resultado", ["No se han encontrado datos con los filtros introducidos."]);
            this.dialogRef.close();
          }
        },
        err => {
          this.data.hojaprin.mostrarArgumentario("Resultado", ["Ha habido un problema al buscar los datos: ", err.message()], false, true, true);
          this.dialogRef.close();
        }).finally(() => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    }
  }

  onPageChange(event: any)
  {
    if(this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
  cargarDetallePeticion(fila:any)
  {
    if(this.controlGestion !== "CORREDORES" && this.controlGestion !== "COLABORADORES RLS"){
      let d = this.dDetalle.open(DetallePeticionComponent,
        {
          data:
            {
              peticion: fila.id,
              token:this.data.token,
              padre:this
            }
        });

      d.afterClosed()
        .subscribe(result=>
        {
          if(result != undefined && result != null && result != "")
          {
            this.dialogRef.close(result);
          }
        })
    }else{
      let d = this.dDetalle.open(DetPeticionCorredoresComponent,
        {
          data:
            {
              peticion: fila.id,
              token:this.data.token,
              padre:this
            }
        });

      d.afterClosed()
        .subscribe(result=>
        {
          if(result != undefined && result != null && result != "")
          {
            this.dialogRef.close(result);
          }
        })
    }

  }
}

export interface PeticionC
{
  id:number;fecha:Date|null;cliente:string;titular:string;cia:string;matricula:string;subDel:string;estado:number;
}

export interface FiltrosBuscadorPeticion
{
  estado:number;
  cia:string;
  id:number;
  fInicio:Date|null;
  fFin:Date|null;
  matricula:string;
}
